import { IPromise, IScope } from "angular";
import { IStateInit } from "@gtmhub/core/routing";
import { IADConnection } from "@gtmhub/integrations/models";
import { StateService } from "@uirouter/angularjs";
import { IntegrationService } from "@gtmhub/integrations/services";
import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { SSOIntegration } from "../models";

export interface ISingleSignOnScope extends IScope {
  ssoConnection: IADConnection;
  indicators;
  error: string;
  integration;
  strategyDisplayName: string;
  addConnection();
  deleteConnection();
  addAlias();
  removeAlias(index: number);
  ssoStrategyChange();
  changeProfilePictureEditingPermission();
}

export class SingleSignOnCtrl implements IStateInit {
  public static $inject = ["$scope", "$state", "IntegrationService", "UIErrorHandlingService"];

  constructor(
    private $scope: ISingleSignOnScope,
    private $state: StateService,
    private integrationService: IntegrationService,
    private uiErrorHandlingService: UIErrorHandlingService
  ) {
    this.$scope.indicators = [];

    this.$scope.addConnection = this.addConnection;
    this.$scope.deleteConnection = this.deleteConnection;
    this.$scope.ssoStrategyChange = this.ssoStrategyChange;
    this.$scope.changeProfilePictureEditingPermission = this.changeProfilePictureEditingPermission;
    this.$scope.ssoConnection = {
      adDomain: "",
      strategy: "waad",
      domainAllias: [],
    };
    this.$scope.strategyDisplayName = "Active Directory";

    this.$scope.addAlias = this.addAlias;
    this.$scope.removeAlias = this.removeAlias;
  }

  public stateInit(): IPromise<unknown> {
    return this.checkIntegration();
  }

  private checkIntegration = (): IPromise<unknown> => {
    this.$scope.indicators.loadingIntegration = true;

    return this.integrationService.getIntegrations().then(
      (integration: SSOIntegration[]) => {
        this.$scope.indicators.loadingIntegration = false;

        if (integration) {
          this.$scope.integration = integration[0];
        } else {
          this.$scope.integration = null;
          this.$scope.$broadcast("focusTextInput");
        }
      },
      (error) => this.uiErrorHandlingService.handleIndicator(error, { indicator: "loadingIntegration", inline: true })
    );
  };

  private deleteConnection = () => {
    this.$scope.indicators.deleteConnection = true;
    this.integrationService.deleteADConnection().then(
      () => {
        this.$scope.indicators.deleteConnection = false;
        this.checkIntegration();
      },
      (error) => {
        this.$scope.indicators.deleteConnection = false;
        this.$scope.error = error;
      }
    );
  };

  private addAlias = () => {
    this.$scope.ssoConnection.domainAllias.push("");
  };

  private removeAlias = (index: number) => {
    this.$scope.ssoConnection.domainAllias.splice(index, 1);
  };

  private addConnection = () => {
    this.$scope.indicators.addingConnection = true;
    this.integrationService.addADConnection(this.$scope.ssoConnection).then(
      (result) => {
        this.$scope.indicators.addingConnection = false;
        this.checkIntegration();
        this.$state.go("._connection.testConnection", { confirmationUrl: result.provisioning_ticket_url });
      },
      (error) => {
        this.$scope.indicators.addingConnection = false;
        this.$scope.error = error;
      }
    );
  };

  private changeProfilePictureEditingPermission = () => {
    this.$scope.integration.canEditPicture = !this.$scope.integration.canEditPicture;
    this.integrationService.updateProfilePictureEditingPermission(this.$scope.integration).then(
      () => {
        this.checkIntegration();
      },
      (error) => {
        this.uiErrorHandlingService.handleModal(error);
      }
    );
  };

  private ssoStrategyChange = () => {
    if (this.$scope.ssoConnection.strategy === "waad") {
      this.$scope.strategyDisplayName = "Active Directory";
    }
    if (this.$scope.ssoConnection.strategy === "google-apps") {
      this.$scope.strategyDisplayName = "Google Workspace";
    }
  };
}
